import React, { useState, useEffect } from "react";
import { getTokenInternal } from "./useToken";

function FriendIcon() {
  const [pendingRequestsCount, setPendingRequestsCount] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await getTokenInternal();
        if (token) {
          const response = await fetch(
            `${process.env.REACT_APP_API_HOST}/api/pending-count`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token.access_token}`,
                "Content-Type": "application/json",
              },
            }
          );

          if (response.ok) {
            const data = await response.json();
            setPendingRequestsCount(data.count);
          } else {
            console.error("Failed to fetch pending requests count");
          }
        }
      } catch (error) {
        console.error("Error fetching pending requests count:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <button
      className="flex text-white font-medium hover:text-gray-400 transition duration-300"
      type="submit"
    >
      Friends
      <div className="ml-2 w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center">
        <span className="text-white text-lg font-bold">
          {pendingRequestsCount}
        </span>
      </div>
    </button>
  );
}

export default FriendIcon;
